import {  MODULE } from "./consts";
import InvoicesDashboard from "./InvoicesDashboard";

export const InvoicesRoutes = [
  { path: `/${MODULE}`, exact: true, component: InvoicesDashboard },
]
export default InvoicesRoutes;
